import { OsmMonitoringType, OsmMonitoringResult, OsmMonitoringEvaluationAction } from 'api';
import { createEnumOptions } from 'const/createEnumOptions';
import {
  getOsmMonitoringEvaluationActionName,
  getOsmMonitoringResultName,
  getOsmMonitoringTypeName,
} from './osmMonitoringHelpers';

export const OSM_MONITORING_TYPE_OPTIONS = createEnumOptions(
  OsmMonitoringType,
  getOsmMonitoringTypeName
);

export const OSM_MONITORING_RESULT_OPTIONS = createEnumOptions(
  OsmMonitoringResult,
  getOsmMonitoringResultName
);

export const EVALUATION_ACTION_OPTIONS = createEnumOptions(
  OsmMonitoringEvaluationAction,
  getOsmMonitoringEvaluationActionName
);

export const VALID_OSM_MONITORING_TYPES = OSM_MONITORING_TYPE_OPTIONS.map((option) => option.value);

export const VALID_OSM_MONITORING_RESULTS = OSM_MONITORING_RESULT_OPTIONS.map(
  (option) => option.value
);
